import { render } from "./OfficeSection.vue?vue&type=template&id=04f46b9b&scoped=true"
import script from "./OfficeSection.vue?vue&type=script&lang=js"
export * from "./OfficeSection.vue?vue&type=script&lang=js"

import "./OfficeSection.vue?vue&type=style&index=0&id=04f46b9b&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04f46b9b"]])

export default __exports__